import axios from 'axios';
import jwt_decode from 'jwt-decode';
import { UID_KEY, EMAIL_KEY, CURRENT_USER_ROLE, DEPARTMENT_OWN } from '../hooks/useLogin';
import { API_URL } from '../utils/constant';
import { TokenExpiredError } from './error';

interface Headers {
  'Content-Type': string;
  Authorization?: string;
}

interface JwtPayload {
  exp: number;
}

export const hopliteAxios = async (method: any, requestUrl: string, data: string | FormData | object, auth: boolean = false) => {
  const headers: Headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
  };
  if (data instanceof FormData) {
    headers['Content-Type'] = 'multipart/form-data';
  } else if (data instanceof Object) {
    headers['Content-Type'] = 'application/json';
  }
  if (auth) {
    const refresh = await checkRefresh();
    if (!refresh) {
      onLogout();
      throw new TokenExpiredError();
    }
    const accessToken = sessionStorage.getItem('ACCESS_TOKEN');
    if (accessToken) {
      headers.Authorization = 'Bearer ' + accessToken;
    }
  }

  const promise = axios({
    method,
    url: API_URL(requestUrl),
    headers,
    data,
  })
    .then(async (response) => {
      return response;
    })
    .catch((error) => {
      throw error.message;
    });
  return await promise;
};

const checkRefresh = async () => {
  // if token is expired. In this case, access token is expired.
  // call ahov4-refresh-token
  const expired = Number(sessionStorage.getItem('expired'));
  if (new Date().getTime() + 10 * 1000 >= expired) { // minus 10 seconds to avoid network delay
    const refreshToken = sessionStorage.getItem('REFRESH_TOKEN');
    if (!refreshToken) {
      return false;
    }

    const result = await axios.post(API_URL('/ahov4-refresh-token'), 'refresh_token=' + refreshToken, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
    if (result.data.status === '1') {
      const decode: JwtPayload = jwt_decode(result.data.tokens.access_token);
      if (decode.exp) {
        sessionStorage.setItem('expired', (decode.exp * 1000).toString());
      }

      sessionStorage.setItem('ACCESS_TOKEN', result.data.tokens.access_token);
      sessionStorage.setItem('REFRESH_TOKEN', result.data.tokens.refresh_token);
      localStorage.setItem('ACCESS_TOKEN', result.data.tokens.access_token);
      localStorage.setItem('REFRESH_TOKEN', result.data.tokens.refresh_token);
    } else {
      return false;
    }
  }
  return true;
};
// authFails
const onLogout = () => {
  sessionStorage.removeItem(UID_KEY);
  sessionStorage.removeItem('expired');
  sessionStorage.removeItem('ACCESS_TOKEN');
  sessionStorage.removeItem('REFRESH_TOKEN');
  sessionStorage.removeItem(EMAIL_KEY);
  sessionStorage.removeItem(CURRENT_USER_ROLE);
  sessionStorage.removeItem(DEPARTMENT_OWN);
};
